import React, { useMemo } from 'react'
import { Pair, Token } from 'vvs-sdk'
import { useFarms } from 'state/farms/hooks'
import { usePairs } from 'hooks/usePairs'

export function useFarmPairs(): Pair[] {
  const { data: farms } = useFarms()
  const farmTokensPairs: [Token, Token][] = useMemo(() => farms.map((farm) => [farm.token, farm.quoteToken]), [farms])
  const allFarmPairs = usePairs(farmTokensPairs)
  return allFarmPairs.map((farmPair) => farmPair[1]).filter((farmPair) => farmPair !== null)
}
